<template>
  <div>
    <Header></Header>
    <!--泛物网络-->
    <section class="top">
      <div>
        <h1>行业解决方案</h1>
        <p>在为不同的行业企业服务过程中，泛物已经为10多个行业做过解决方案,<br>
        这些将帮助我们更加快速，精准的理解客户的生产工艺和系统需求，并高效的为客户服务
        </p>
      </div>
    </section>

    <div class="programme">
      <div class="programme-left" :class="policy==1?'National':''" ref='piediv'>
        <div class="title">解决方案</div>
        <ul>
          <li :class="plan==0?'liCor':''" @click="plan = 0"><img src="http://www.ibiandan.cn/repository/image/dca74a07-6d7d-40ce-8b8e-dbd63685194c.png" alt="">泛物网络售电支持平台</li>
          <li :class="plan==1?'liCor':''" @click="plan = 1"><img src="http://www.ibiandan.cn/repository/image/dca74a07-6d7d-40ce-8b8e-dbd63685194c.png" alt="">泛物网络数据监控平台</li>
          <li :class="plan==2?'liCor':''" @click="plan = 2"><img src="http://www.ibiandan.cn/repository/image/dca74a07-6d7d-40ce-8b8e-dbd63685194c.png" alt="">泛物网络物联网中心平台</li>
          <li :class="plan==3?'liCor':''" @click="plan = 3"><img src="http://www.ibiandan.cn/repository/image/dca74a07-6d7d-40ce-8b8e-dbd63685194c.png" alt="">泛物网络城市供水管网检测平台</li>
        </ul>
      </div>
      <div class="programme-right" v-for="item in arr[plan]">
        <div class="programme-title">
          {{item.name}}
        </div>
        <div class="conten" v-for="i in item.list">
          <h3 class="conten-title">{{i.title}}</h3>
          <p v-for="j in i.text">{{j}}</p>
          <div style="text-align: center;" v-for="y in i.imgurl"><img :src="y" alt=""></div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>

  export default {
    name: "Information",
    data() {
      return {
        // 判断选择
        plan: 0,
        //滚动条判断 固定定位
        policy:0,
        arr: [
          // 泛物售电支持平台 页面数据
          [{
              name: "方案概括",
              list: [{
                title: "",
                text: [
                  "泛物网络售电支持平台包含购电管理、 售电管理、数据采集、客户关系管理、统计查询等配售电关键 环节的业务信息系统高度耦合，实现业务应用的灵活开发与落地， 构建电力能源互联新生态。提供专业的综合电力服务解决方案，帮助能源企业应对市场变革与竞争挑战，快速搭建标准化或定制化商业平台。"
                ],
                imgurl: ['../../static/img/1606726455(1).png'],
              }]
            },
            {
              name: "系统及组成",
              list: [{
                title: "系统整体架构",
                text: ["提供基于不同行业、不同类型用户基于不同影响因素的月度，日内负荷预测技术",
                  "根据各省交易规则及个性化结算需求针对不同用户进行配置",
                  "提供售电合同管理功能，助于售电公司整体管理水平的提升",
                  "统一的精细化管理帮助售电公司维系老客户、发展新客户，拓展业务规模，实现互利共赢"
                ],
                imgurl: [
                  '../../static/img/20201203141557.png',
                ],
              }, ]
            },
          ],
          // 泛物数据监控平台 页面数据
          [{
              name: "方案概括",
              list: [{
                title: "",
                text: [
                  "泛物网络数据监控平台将大数据存储、分析、应用及云计算方面的技术与物联网通讯、设备远程智能维护服务有效结合。应用于能源行业、工业企业、工业园区等相关领域，对能源仪表及设备实时监控和控制，实现对生产过程的精细化管理，进一步规范企业能源管理，将低耗能，提高生产效率。"
                ],
                imgurl: ['../../static/img/20201203184512.png'],
              }]
            },
            {
              name: "系统及组成",
              list: [{
                title: "系统整体架构",
                text: ["设备接入：支持泛物网络及多种网络和多种协议类型的设备接入，支持百万级别消息秒级并发",
                  "设备管理：提供远程配置设备，远程监控设备，远程升级，远程调试",
                  "时间数据存储：对企业数据进行时序库储存，以秒为储存节点，进行时序对比计算，通过高效的时序对比计算，进行案例分析",
                  "扩展性强：通过海量的数据存储和分析，随着业务的发展，数据的扩展将直接影响对实例的诊断",
                ],
                imgurl: ['../../static/img/20201203184227.png'],
              }, ]
            },
          ],
          // 泛物云物联网中心平台 页面数据
          [{
              name: "方案概括",
              list: [{
                title: "",
                text: [
                  "泛物网络物联网平台是泛物网络应用的基础平台，全新的物联网结构，是云盒产品的灵魂，5000P的时序存储和超级计算为核心打造新型的数据中心结构，让超级计算为基础技术服务，开创用能节能的新时代"
                ],
                imgurl: ['../../static/img/1606726599(1).png'],
              }]
            },
            {
              name: "系统及组成",
              list: [{
                title: "系统整体架构",
                text: ["支持大规模分布式部署，海量连接，性能强悍",
                  "物联设备一站式接入集成，可视化配置",
                  "支持百亿级数据的存储、查询和聚合分析",
                  "内置高速规则引擎，快速应用集成",
                  '跨平台可伸缩，适配各种类型和规模的基础设施'
                ],
                imgurl: ['../../static/img/202011301659.png'],
              }, ]
            },
          ],
          // 城市供水管网检测检查系统 页面数据
          [{
              name: "方案概括",
              list: [{
                title: "",
                text: [
                  "泛物网络城市供水管网检测平台 是利用世界首款管道内无人潜航器对供水管道进行三维地图造影，利用声波定位，分段式影像数据传输，造影对比绘制管道内的损坏模型，为有效降低漏失率提供解决方案。"
                ],
                imgurl: ['../../static/img/20200731103459.png'],
              }]
            },
            {
              name: "系统及组成",
              list: [{
                title: "系统整体架构",
                text: ["利用声波定位，分段式影像数据传输。",
                "特有的分布式信号传输方式完美解决了检测设备与监测系统的衔接",
                "可以简单有效的绘制管网漏失损坏三维模型。",
                "造影对比绘制管道内的损坏模型，为有效降低漏失率"],
                imgurl: ['../../static/img/202011301621.png'],
              }, ]
            },
          ],
        ]
      };
    },
    mounted() {
      console.log(this.$route.query.tid);
      if(this.$route.query.tid!=undefined){
        this.plan = this.$route.query.tid-1
      }
      window.addEventListener('scroll', this.getScroll);
    },
    methods: {
      //监听滚动
      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(this.scrollTop>=440){
          this.policy = 1
        }else{
          this.policy = 0
        }
      },
      // 跳转
      goto(page,selectId){
        var path = page;
        var selectId = selectId;
        localStorage.setItem("toId",selectId);
        this.$router.push({name: path, query: {info:true}});
      }
    }
  };
</script>

<style scoped="scoped" lang="scss">
  .top {
    height: 450px;
    /* background-color: #201f3f; */
    background-image: url(../../static/img/topbgimg2.jpg);
    background-repeat: no-repeat;
    /* background-size: 100% 100%; */
    position: relative;
    div{
      position: absolute;
      left: 18%;
      top: 42%;
      z-index: 9;
      h1 {
        color: #FFFFFF;
        &::before{
          content: '';
          width: 40px;
          height: 4px;
          margin-left: 8px;
          background-color: #FFFFFF;
          position: absolute;
          top: 60px;
          left: 0;
        }
      }
      p{
        margin-top: 30px;
        font-size: 17px;
        color: #FFFFFF;
      }
    }
  }

  .top::before {
    opacity: 0.5;
    background: #000;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }



  .translates {
    height: 64px;
    background: #f0f2f5;
    margin-bottom: 100px;


    .translates-anchor {
      width: 1128px;
      margin: 0 auto;
      position: relative;
       .lx-btn{
         font-size: 14px;
             height: 64px;
             line-height: 64px;
             background-color: #09f;
             color: #fff;
             padding: 0 24px;
             position: absolute;
             right: 0;
             top: 0;
             cursor: pointer;
       }
      ul {
        width: 100%;

        li {
          float: left;
          display: block;
          height: 64px;
          line-height: 64px;
          margin-right: 88px;
          font-size: 16px;
          cursor: pointer;
        }


      }
    }
  }

  .programme {
    width: 1440px;
    margin: 0 auto;
    border-bottom: dotted 1px #ced1d7;
    position: relative;
    &:after{
      content: "020";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
      }
    & {
      /* 触发 hasLayout */
      zoom: 1;
      }
    .National{
      position: fixed;
      top: 0;
    }
    .programme-left{
      float: left;
      width: 288px;
      margin-top: 60px;
      .title{
        width: 100%;
        height: 73px;
        background-color: #226db4;
        text-align: center;
        line-height: 73px;
        font-size: 30px;
        max-width: 600px;
        color: #fff;
      }
      ul {
        border: 1px solid #f0f0f0;
        li{
          font-size: 16px;
          background-color: #ffffff08;
          color: #333;
          padding: 12px 20px;
          border-bottom: 1px solid #e8e8e8;
          cursor: pointer;
          &:hover{
            background-color: #226db4;
            color: #fff;
          }
          img{
            margin-right: 12px;
          }
        }
        .liCor {
          background-color: #226db4;
          color: #fff;
        }
      }
    }
    .programme-right{
      padding-left: 40px;
      width: 80%;
      float: right;
    }
    .programme-title {
      border-left: 2px solid #09f;
      padding-left: 6px;
      color: #2e3746;
      font-size: 24px;
      margin-top: 60px;
      margin-bottom: 28px;
      line-height: 1em;
      font-weight: 300;
    }

    .conten {
      padding-bottom: 50px;
      .conten-title {
        font-size: 16px;
        color: #2e3746;
        margin: 30px 0;
        font-family: '微软雅黑', sans-serif;
        font-weight: 900;
      }
      img{
        width: 100%;
      }
      p {
        margin-top: 4px;
        line-height: 32px;
        color: #606775;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Information.vue